<template>
    <div>
        <div class="home-wrap">
            <page01 class="home-page"></page01>
            <news-page class="home-page"></news-page>
            <!-- <page02 class="home-page"></page02> -->
            <character-page class="home-page"></character-page>
            <story-page class="home-page"></story-page>
            <gallery-page class="home-page"></gallery-page>
            <commicPage  class="home-page" ></commicPage>
            <Sns-page class="home-page"></Sns-page>
            <footer-bar class="home-page last-page"></footer-bar>
        </div>
    </div>
</template>

<script>
import CommicPage from '../../pages/home/Commic.vue'
import "../../plugins/fullpage.min.js";
import footerBar from "../../components/footer";
import page01 from "./page01.vue";
import page02 from "./page02.vue";
import characterPage from "./Character.vue";
import storyPage from "./Story.vue";
import galleryPage from "./Gallery.vue"
import newsPage from "./News.vue"
import SnsPage from "./Sns.vue"

export default {
    name: "home-main",

    components: {
        page01,
        page02,
        characterPage,
        footerBar,
        storyPage,
        galleryPage,
        SnsPage,
        newsPage,
        CommicPage
    },
    data: () => ({
        fullpage: null,
    }),
    created() {

    },
    mounted() {
        this.fullpage = new FullPage({
			containerClassName: ".home-wrap",
			pageClassName: ".home-page",
            disableSrcollClassName: [],
            lastBar: true
        })
        window.fullpage = this.fullpage
        this.fullpage.init();
        this.$store.commit("INIT_HOME_FULLPAGE", this.fullpage);

        if(this.$route.params.navIndex >= 0) {
			this.fullpage.goTo(this.$route.params.navIndex + 1)
		}
    },
    
    watch: {
    },
    computed: {
        NAV_ACTIVE_INDEX() {
            // 导航栏激活指数
            if (this.$store.state.HOME_FULLPAGE) {
                // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        },
    },
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.home-wrap {
    width: 100%;
	.home-page {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }
    .last-page {
        height: auto !important;
    }
}
</style>
